import script from "./NoAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./NoAssistant.vue?vue&type=script&setup=true&lang=js"

import "./NoAssistant.vue?vue&type=style&index=0&id=1221bcf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1221bcf2"]])

export default __exports__